export default __webpack_public_path__ + "static/media/SFG-GlyGen-GlycoTree-Nov-2020.571ddc55.pdf";